import { AssetVersionDto } from '@nusign/picflow-backend-types';

export const getAssetDimentions = (version: AssetVersionDto, defaultValue = { width: 1, height: 1 }, page = 0) => {
  if (!version) return defaultValue;

  if (version.data?.width) {
    return {
      width: Number(version.data.width),
      height: Number(version.data.height),
    };
  }

  if (version.data?.['images']) {
    const img = version.data['images'][page];
    return {
      width: Number(img.width),
      height: Number(img.height),
    };
  }

  return defaultValue;
};
